<template>
    <div>
        <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/CAC/conference.png" :width="'100%'" />
        <div class="bl-find-r-page2">
            <div v-for="item in activityTypeList" :key="item.id" class="btn mr6 font-size-13 pointer"
                :class="{ 'activeBtn': item.id == activityId }" @click="searchActivity(item.id)">
                {{ item.activityType }}
            </div>
        </div>
        <div class="meeting-list" v-loading="meetingLoading">
            <div class="container">
                <div v-if="dataList.length" class="list">
                    <el-row :gutter="20" class="flex fs as fw">
                        <el-col v-for="(item,index) in dataList" :key="index" :xs="24" :sm="12" :md="12" :lg="12">
                            <div class="metting-item flex ac pointer" @click.stop="goDetail(item.id)">
                                <div class="metting-item-div">
                                    <div class="title ellipsis">{{ item.enActivityTheme }}</div>
                                    <div class="date">
                                        <span style="margin-right: 8px;">{{ item.activityStartDate |
                                            formatDate('y-m-d') }}</span>
                                        <!-- <span>{{ item.activityStartDate | formatDate('hours') }}</span> -->
                                    </div>
                                    <div class="roomName">{{ item.enAddress}}</div>
                                </div>
                                <div style="margin-left: 20px;">
                                    <el-button size="small" type="primary"
                                        @click.stop="goSignUp(item)">Application</el-button>
                                </div>

                            </div>
                        </el-col>
                    </el-row>
                </div>
                <el-empty v-else :description="$t('没有记录')" />
                <!-- <el-pagination v-if="dataList.length" background :page-size="form.pageRows"
                    :current-page.sync="form.pageNum" layout="total, prev, pager, next, jumper" :total="total"
                    class="bl-page" @current-change="handleCurrentChange" /> -->
            </div>
        </div>
    </div>
</template>
<script>
import {
    activityQueryList
} from '@/api/index'
import { loadActivityType } from '@/api/live'

export default {
    data() {
        return {
            meetingLoading:false,
            productList: [], // 展品列表
            dataList: [], // 数据列表
            total: 0,
            activityTypeList: [], // 活动类型
            activityId: '', // 选中值
        }
    },
    mounted() {
        this.getActivityType()
        this.getDataList('')
    },
    methods: {
        // 报名
        goSignUp(item) {
            console.log('item------>', item)
            if (item.activeUrl) {
                window.open(item.activeUrl, '_blank')
            }
        },
        // 选中筛选
        searchActivity(id) {
            if (this.activityId === id) {
                this.activityId = ''
            } else {
                this.activityId = id
            }
            this.getDataList(id)
        },
        //   获取活动分类
        getActivityType() {
            loadActivityType({
                useType: 1
            }).then(res => {
                let data = [
                    {
                        id: '',
                        activityType: 'All'
                    }
                ]
                this.activityTypeList = data.concat(res.data.data || [])
            })
        },
        // 跳转详情
        goDetail(id) {
            this.$router.push(`/meetingList/${id}`)
        },
        // 时间转换
        formatDate(date) {
            return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
        },
        // 设置loading
        setLoading(val) {
            this.meetingLoading = val
        },
        // 获取数据列表
        async getDataList(typeId) {
            this.meetingLoading = true
            const res = await activityQueryList({ typeId})
            if (res.data.code == 1000) {
                
                this.dataList = res.data.data || []
                // const {
                //     list,
                //     total
                // } = res.data.data
                // this.dataList = list
                // this.total = total
            }
            this.meetingLoading = false
        },
        // 分页切换
        handleCurrentChange(val) {
            this.form.pageNum = val
            this.getDataList('')
        },
    }
}
</script>
<style
    lang="stylus"
    scoped
>
.meeting-list {
    padding: 20px 10px 50px 10px;

}
.container{
    max-width: 1366px;
    margin: 0 auto;
}
:dppe .el-input__inner{
    height:32px !important
}

.metting-item
  background: $color-white;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
  &:hover
    cursor pointer
    box-shadow 0 6px 5px 5px $box-shadow1, 0 6px 8px 2px $box-shadow2  
.more-btn{
  margin-top:24px;
  font-weight: 400;
  font-size: 14px;
  color: $color-main;
  line-height: 14px;
  text-align: center;
}
.title{
  font-weight: 600;
  font-size: 18px;
  color: $color-black-85;
  line-height: 24px;
  margin-bottom:16px;
}
.date{
  font-weight: 400;
  font-size: 14px;
  color: $color-black-45;
  line-height: 14px;
  margin-bottom:8px;
}
.roomName{
  color: $color-main;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
}
.btn {
    min-width: 98px;
    height: 33px;
    border-radius: 4px;
    text-align: center;
    line-height: 33px;
    border: 1px solid $color-main;
    color:$color-main;
    padding:0px 20px;
}

.bl-find-r-page2{
  max-width: 1366px;
  margin: 10px auto;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding:20px 20px 12px 20px;
}
.activeBtn {
    color:$color-white;
    border: 1px solid $color-main;
    background:$color-main;
}

</style>
<style lang="scss" scoped>
.metting-item-div {
    width: 80%;
}

@media (min-width: 320px) and (max-width: 750px) {
    .metting-item-div {
        width: 60%;
    }
}
</style>
